import {Component, inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {InputComponent} from '../form/input/input.component';

export interface NameFormData {
  firstName: string;
  lastName: string;
}

interface NameDetailsForm {
  firstName: FormControl<string | null>;
  lastName: FormControl<string | null>;
}

/**
 * Wiederverwendbare Namens-Formularlogik - eingebettet sowohl im Verifizierungs-Wizard
 * (NameStepComponent) als auch im NameDetailsAdjustModalComponent.
 */
@Component({
  selector: 'app-name-details-form',
  standalone: true,
  imports: [TranslatePipe, ReactiveFormsModule, InputComponent],
  templateUrl: './name-details-form.component.html',
})
export class NameDetailsFormComponent implements OnInit {

  @Input() initialData: NameFormData | null;
  // Erlaubt unterschiedliche data-cy-Präfixe je nach Einbettungskontext (Wizard-Step vs. Modal)
  @Input() testIdPrefix = 'name-data-';

  form: FormGroup<NameDetailsForm>;

  private readonly fb = inject(FormBuilder);

  ngOnInit(): void {
    this.form = this.fb.group({
      firstName: new FormControl(this.initialData?.firstName ?? '', [Validators.required]),
      lastName: new FormControl(this.initialData?.lastName ?? '', [Validators.required]),
    });
  }

  isValid(): boolean {
    return this.form.valid;
  }

  getFormValue(): NameFormData {
    return this.form.getRawValue() as NameFormData;
  }
}
